import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { Provider } from 'react-redux';
// ESTILOS
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './App.css';
import MainLoader from './components/Loaders/MainLoader';

//ROUTES
import routes from './routes';
import store from './store';
import ProtectedRoutes from './components/protectedRoutes/ProtectedRoutes';
import publicRoutes from './publicRoutes';
import ProtectedPublicRoutes from './components/protectedRoutes/ProtectedPublicRoutes';
//PANEL
import Login from './containers/auth/panel/Login';
import ForgotPasswordForm from './containers/auth/panel/ForgotPasswordForm';
import ChangePasswordForm from './containers/auth/panel/ChangePasswordForm';

import LoginPublic from './containers/auth/public/LoginPublic';
import ForgotPasswordPublic from './containers/auth/public/ForgotPasswordPublic';
import ChangePasswordPublic from './containers/auth/public/ChangePasswordPublic';
import CreateAccountPublic from './containers/auth/public/CreateAccountPublic';
import ActivateAccountPublic from './containers/auth/public/ActivateAccountPublic';


function App() {
  return (
    <React.Suspense fallback={<MainLoader />}>
      <HelmetProvider>
        <Provider store={store}>
          <BrowserRouter>
            <div className="h-full min-h-screen">
              <Routes>
                {/* Rutas protegidas */}
                <Route element={<ProtectedRoutes />}>
                  {routes.map(route => (
                    <Route key={route.path} path={route.path} element={<route.component />} />
                  ))}
                </Route>
                <Route path="/panel" element={<Login />} />
                <Route path="/panel/forgotPassword" element={<ForgotPasswordForm />} />
                <Route path="/panel/changePassword/:user_id" element={<ChangePasswordForm />} />
                <Route path="/" element={<LoginPublic />} />
                <Route path="/create_account" element={<CreateAccountPublic />} />
                <Route path="/activar_cuenta/:parent_id" element={<ActivateAccountPublic />} />
                <Route path="/forgot_password" element={<ForgotPasswordPublic />} />
                <Route path="/change_password/:parent_id" element={<ChangePasswordPublic />} />
                {/* Rutas públicas con PublicLayout */}
                <Route element={<ProtectedPublicRoutes />}>
                  {publicRoutes.map(route => (
                    <Route key={route.path} path={route.path} element={<route.component />} />
                  ))}
                </Route>

              </Routes>
            </div>
          </BrowserRouter>
        </Provider>
      </HelmetProvider>
    </React.Suspense>
  );
}

export default App;
